// extracted by mini-css-extract-plugin
module.exports = {"icon":"WelcomeStep_icon__1LYpG","title":"WelcomeStep_title__3cY1g","subtitle":"WelcomeStep_subtitle__2DHNf"};